import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { setShopLoading, setShopLoaded } from '../../store/actions/Shop';

function mapStateToProps(state) {
   return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setShopLoading: () => {
      dispatch(setShopLoading());
    },
    setShopLoaded: () => {
      console.log('shopify buy 4')
      dispatch(setShopLoaded());
    }
  }
}

class ShopifyStore extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }  

  componentDidMount() {
    // Shopify JS Integration
    const { setShopLoading } = this.props;
    let t = this;
    setShopLoading();

    // let shopId = 81921278006;   // Printful Stock
    let shopId = 176894771254;     // Our Stock
    let buttonColor = '#FFD44C';
    let buttonColorDark = '#EBC03A';
    let buttonTextColor = "#000000"

    /*<![CDATA[*/
    var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    if (window.ShopifyBuy) {
      if (window.ShopifyBuy.UI) {
        ShopifyBuyInit();
      } else {
        loadScript();
      }
    } else {
      loadScript();
    }

    function loadScript() {
      var script = document.createElement('script');
      script.async = true;
      script.src = scriptURL;
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
      script.onload = ShopifyBuyInit;
    }

    function ShopifyBuyInit() {

      var client = ShopifyBuy.buildClient({
        domain: 'fuck-2016-online-store.myshopify.com',
        storefrontAccessToken: '1afd86c85ffbfca0012f13d4daf2c00b', 
        appId: '6',
      });

      ShopifyBuy.UI.onReady(client).then(function (ui) {

        ui.createComponent('collection', {
          id: shopId,
          node: document.getElementById('collection-component-shop'),
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            "product": {
              "variantId": "all",
              "contents": {
                "imgWithCarousel": false,
                "variantTitle": false,
                "description": false,
                "buttonWithQuantity": false,
                "quantity": false
              },
              "styles": {
                "product": {
                  "@media (min-width: 601px)": {
                    "max-width": "calc(25% - 20px)",
                    "margin-left": "20px",
                    "margin-bottom": "50px"
                  }
                },
                "button": {
                  "background-color": buttonColor,
                  "color": buttonTextColor,
                  "font-size": "15px",
                  "font-weight": "bold",
                  "@media (max-width: 601px)": {
                      "width": "100%",
                      "max-width": "280px",
                      "margin-bottom": "20px !important"
                  },
                  ":hover": {
                    "background-color": buttonColorDark
                  },
                  ":focus": {
                    "background-color": buttonColorDark
                  }
                }
              }
            },
            "cart": {
              "contents": {
                "button": true
              },
              "text": {
                "total": "Total"
              },
              "styles": {
                "button": {
                  "background-color": buttonColor,
                  ":hover": {
                    "background-color": buttonColorDark
                  },
                  ":focus": {
                    "background-color": buttonColorDark
                  }
                },
                "footer": {
                  "background-color": "#ffffff"
                }
              }
            },
            "modalProduct": {
              "contents": {
                "img": false,
                "imgWithCarousel": true,
                "variantTitle": false,
                "buttonWithQuantity": false,
                "quantity": false
              },
              "styles": {
                "product": {
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                  }
                },
                "button": {
                  "background-color": buttonColor,
                  "font-size": "15px",
                  ":hover": {
                    "background-color": buttonColorDark
                  },
                  ":focus": {
                    "background-color": buttonColorDark
                  }
                }
              }
            },
            "toggle": {
              "styles": {
                "toggle": {
                  "background-color": buttonColor,
                  ":hover": {
                    "background-color": buttonColorDark
                  },
                  ":focus": {
                    "background-color": buttonColorDark
                  }
                }
              }
            },
            "productSet": {
              "styles": {
                "products": {
                  "@media (min-width: 601px)": {
                    "margin-left": "-20px"
                  }
                }
              }
            }
          }
        })
        // .then(function() {
        //   // Shop has finished loading
        //   console.log('shopify buy 3')
        //   t.props.setShopLoaded();
        // });

      });

    }
    /*]]>*/
  }

  render() {
    const { } = this.props;

    return (
      <div>
        <div id='collection-component-shop'></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopifyStore);










// WEBPACK FOOTER //
// ./src/containers/ShopifyStore/ShopifyStore.js